<h1>Angular UI Scroll Demo App</h1>

<p>
  <em>ngx-ui-scroll</em> is the Angular library for large datasets
  virtualization. More information regarding motivation, infrastructure,
  features, developing can be found on
  <a href="https://github.com/dhilt/ngx-ui-scroll">GitHub</a>. This site is
  dedicated to practical examples of <em>ngx-ui-scroll</em> usage.
</p>

<div class="demo">
  <h3>Common demo</h3>
  <div class="work">
    <div class="viewport-wrapper">
      <div class="viewport">
        <div *uiScroll="let item of datasource; let even = even">
          <div class="item" [class.even]="even">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <div class="log">
      <div style="line-height: 25px; margin-bottom: 2px">
        ngx-ui-scroll v{{ datasource.adapter.packageInfo.consumer.version }}
        <br />
        ({{ datasource.adapter.packageInfo.core.name }} v{{
          datasource.adapter.packageInfo.core.version
        }}, angular v{{ angularVersion }})
        <br />
        First visible: #{{ (datasource.adapter.firstVisible$ | async)?.$index }}
        <br />
        Last visible: #{{ (datasource.adapter.lastVisible$ | async)?.$index }}
        <br />
        Items in DOM: {{ itemsCount() }}
        <br />
        Is loading: {{ datasource.adapter.isLoading$ | async }}
        <br />
      </div>
      <div style="display: flex; align-items: center; margin-bottom: 2px">
        Datasource delay (ms):&nbsp;
        <input [(ngModel)]="delay" type="number" style="width: 84px" />
      </div>
      <div style="display: flex; align-items: center">
        Index to reload:&nbsp;
        <input
          [(ngModel)]="reloadIndex"
          type="number"
          style="width: 60px"
        />&nbsp;
        <button (click)="doReload()" style="width: 60px">Reload</button>
      </div>
    </div>
    <div class="clearfix mb-3"></div>
  </div>

  <div class="sources">
    <tabset>
      <tab heading="{{ sources[0].name }}">
        <pre class="prettyprint lang-html">{{ sources[0].text }}</pre>
      </tab>
      <tab heading="{{ sources[1].name }}">
        <pre class="prettyprint">{{ sources[1].text }}</pre>
      </tab>
      <tab heading="{{ sources[2].name }}">
        <pre class="prettyprint lang-html">{{ sources[2].text }}</pre>
      </tab>
      <tab heading="{{ sources[3].name }}">
        <pre class="prettyprint">{{ sources[3].text }}</pre>
      </tab>
    </tabset>
  </div>
</div>

<p>
  This particular demo includes simplest virtual list template (tab 1), basic
  Datasource implementation with configurable delay and reload (tab 2), some of
  the Adapter read-only properties output (tab 3), simplest styling (tab 4).
  Many
  other samples with all necessary details and explanations can be found at
  <a routerLink="{{ scopes.datasource.id }}">{{ scopes.datasource.name }}</a
  >, <a routerLink="{{ scopes.settings.id }}">{{ scopes.settings.name }}</a
  >, <a routerLink="{{ scopes.adapter.id }}">{{ scopes.adapter.name }}</a> and
  <a routerLink="{{ scopes.experimental.id }}">{{
    scopes.experimental.name
  }}</a>
  sections. Below is the list of all examples available in these sections.
</p>

<h3>Example list</h3>
<div style="display: flex" class="demo-examples">
  <div *ngFor="let scope of demosNotEmpty">
    <h5>{{ scope.name }}</h5>
    <span *ngFor="let demo of scope.map">
      <a routerLink="{{ scope.id }}" fragment="{{ demo.id }}">
        {{ demo.name }} </a
      ><br />
    </span>
  </div>
</div>
